import { asDecimal } from '@helpers/utils'
import Decimal from 'decimal.js'

interface Price {
  sell_price: string
  declared_sell_price: string
  promotion_multiplier: string
}

interface Response {
  sellPrice: Decimal
  bonusPrice: string
  promotionPercentage: string
}

export const getGastroProductPrice = <T extends Price>(details: T): Response => {
  const sellPrice = asDecimal(details.sell_price)

  const bonusPrice = asDecimal(sellPrice.gt(asDecimal(0)) ? details.sell_price : details.declared_sell_price)
    .mul(details.promotion_multiplier)
    .toString()

  const promotionPercentage = asDecimal(details.promotion_multiplier).sub(1).mul(100).toString()

  return { sellPrice, bonusPrice, promotionPercentage }
}
